export const refreshSvg = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Refresh</title>
    <path
      d="M15.9852 5.32694C10.0942 5.32694 5.31852 10.1026 5.31852 15.9936C5.31852 21.8846 10.0942 26.6603 15.9852 26.6603C21.4247 26.6603 25.9132 22.5887 26.5693 17.3269H29.2527C28.5837 24.0647 22.899 29.3269 15.9852 29.3269C8.62139 29.3269 2.65186 23.3574 2.65186 15.9936C2.65186 8.62982 8.62139 2.66028 15.9852 2.66028C20.3471 2.66028 24.2197 4.7548 26.6523 7.99294L29.3184 5.3269V13.3269H21.3184L24.7428 9.90246C22.8156 7.13675 19.6117 5.32694 15.9852 5.32694Z"
      className="fill-ock-foreground"
    />
  </svg>
);
